import { isBefore, isValid } from 'date-fns'

/**
 * From 01/10/2026 Meta changed how service messages are billed, so a period that mixes the
 * two rules produces numbers that cannot be compared. Dates are the picker's (browser local time).
 */
export const META_BILLING_CUTOFF = new Date(2026, 9, 1)

export const META_BILLING_PERIOD_MESSAGE =
  'Não é possível consultar um período que atravessa 01/10/2026, pois a Meta alterou a cobrança das mensagens de serviço nessa data. Selecione um período inteiramente antes ou a partir de 01/10/2026.'

/**
 * @param {[Date, Date]} range picker period
 * @returns {string | null} the reason the period is blocked, or null when it is allowed
 */
export function validateMetaBillingPeriod([start, end] = []) {
  if (!isValid(start) || !isValid(end)) return null

  return isBefore(start, META_BILLING_CUTOFF) && !isBefore(end, META_BILLING_CUTOFF)
    ? META_BILLING_PERIOD_MESSAGE
    : null
}

/**
 * A period whose end is before the cutoff keeps the old report (no Serviço).
 * @param {number} endTimestampSeconds end of the period, unix seconds
 */
export function isBeforeMetaBillingCutoff(endTimestampSeconds) {
  const end = new Date(endTimestampSeconds * 1000)
  return isValid(end) && isBefore(end, META_BILLING_CUTOFF)
}
